<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Group">
<path id="Vector" d="M13.5011 26.4984C20.6804 26.4984 26.5003 20.6784 26.5003 13.4992C26.5003 6.31993 20.6804 0.5 13.5011 0.5C6.32189 0.5 0.501953 6.31993 0.501953 13.4992C0.501953 20.6784 6.32189 26.4984 13.5011 26.4984Z" fill="#FF305C"/>
<g id="Group_2">
<path id="Vector_2" d="M9.49414 15.1572V20.6195H12.0616V15L9.49414 15.1572Z" fill="#171717"/>
<path id="Vector_3" d="M14.9253 6.28906V12.2835H12.0615V8.90069H9.49406V12.2802L6.89062 12.3032L9.49406 14.7592H15.9273L14.9253 14.8215V18.0242H17.5189V6.28906H14.9253Z" fill="#171717"/>
</g>
</g>
</svg>
